module.exports = __webpack_public_path__ + "static/media/AragonShcoenfeld.2da2fc6b.webp";